import React from 'react';
import { colorConstants } from 'config/colorConstants';

const BulkUpdateIcon = ({
    width = 16,
    height = 16,
    fill = colorConstants.blackTransparent88,
    className,
}: {
    width?: number;
    height?: number;
    fill?: string;
    className?: string;
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6.66667C0 2.98477 2.98477 0 6.66667 0C8.50826 0 10.1765 0.747596 11.3823 1.95425C11.8088 2.38097 12.2654 2.90832 12.6667 3.39629V1.33333C12.6667 0.965143 12.9651 0.666667 13.3333 0.666667C13.7015 0.666667 14 0.965143 14 1.33333V5.33333C14 5.70152 13.7015 6 13.3333 6H9.33333C8.96514 6 8.66667 5.70152 8.66667 5.33333C8.66667 4.96514 8.96514 4.66667 9.33333 4.66667H11.9795C11.518 4.08752 10.9444 3.40224 10.4392 2.89674C9.47323 1.93009 8.14027 1.33333 6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61218 3.72115 12 6.66667 12C9.09716 12 11.1495 10.3737 11.7916 8.1485C11.8937 7.79474 12.2632 7.59072 12.617 7.6928C12.9707 7.79488 13.1748 8.16441 13.0727 8.51817C12.2703 11.2987 9.70697 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667Z"
                fill={fill}
            />
        </svg>
    );
};

export default BulkUpdateIcon;
